module.exports = __webpack_public_path__ + "static/media/rsebastian1_1706524333769.9e1a47fe.png";